import React, { Component } from 'react';
import { formatoDecimal } from '../../../utilities/formatoNumeros';
import { idEstadoRebate, switchCardRebate } from '../../../helper/rebateHelper';
import { toast } from '../../../utilities/appToast';
import '../Styles/Rebates.css';

export default class RebateListItem extends Component {
  resolveImageSrc = (src) => {
    const value = src != null ? String(src).trim() : '';
    return value || 'https://www.megatone.net/Images/Marketplaces/EnProceso_zoom2x.png';
  };

  copyAlPortapapeles = async (e, valor, etiqueta) => {
    if (e?.stopPropagation) e.stopPropagation();
    if (valor === undefined || valor === null || String(valor).trim() === '') return;
    try {
      await navigator.clipboard.writeText(String(valor));
      toast.success(`${etiqueta} copiado`);
    } catch {
      toast.error('No se pudo copiar al portapapeles');
    }
  };

  copyTargetKeyDown = (e, valor, etiqueta) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      this.copyAlPortapapeles(e, valor, etiqueta);
    }
  };

  renderCopyControl = (valor, etiqueta, children, className, title) => (
    <span
      role="button"
      className={className}
      title={title}
      tabIndex={0}
      onClick={(e) => this.copyAlPortapapeles(e, valor, etiqueta)}
      onKeyDown={(e) => this.copyTargetKeyDown(e, valor, etiqueta)}
      style={{ border: 'none', background: 'none', padding: 0, cursor: 'copy' }}
    >
      {children}
    </span>
  );

  render = () => {
    const {
      idRebate,
      idPublicacion,
      descripcionSeller,
      imagen,
      titulo,
      estadoRebate,
      skuSeller,
      skuMarket,
      precioLista,
      fechaInicio,
      fechaVencimiento,
      porcentajeTotalDescuento,
      aCargoMegatone,
      porcentajeMegatone,
      aCargoSeller,
      porcentajeSeller,
      unidades,
      unidadesRestantes,
      precioFinal,
      tipoPublicacion,
      userType
    } = this.props;

    const btnEliminar = {
      style: "background-rojo-megatone",
      action: () => this.props.deleteRebate(idRebate),
      descripcion: "Eliminar Rebate"
    };

    const btnVerDetalle = {
      style: "btn-grey",
      action: () => this.props.onPublicacion(idPublicacion),
      descripcion: "Ver Detalle"
    };

    const btnAprobar = {
      style: "btn-green",
      action: () => this.props.handleEstadoRebate(idRebate, idEstadoRebate.aprobado),
      descripcion: <i className="mdi mdi-check" />
    };

    const btnRechazar = {
      style: "background-rojo-megatone",
      action: () => this.props.handleEstadoRebate(idRebate, idEstadoRebate.rechazado),
      descripcion: <i className="mdi mdi-close" />
    };

    let btn1;
    let btn2;

    switch (estadoRebate) {
      case "Activo":
        btn1 = { ...btnEliminar, descripcion: "Eliminar Rebate" };
        btn2 = (btnVerDetalle);
        break;
      case "En revision":
        if (!userType.isSellerAdmin) {
          btn1 = (btnEliminar);
          btn2 = (btnVerDetalle);
        } else {
          btn1 = (btnAprobar);
          btn2 = (btnRechazar);
        }
        break;
      case "Pendiente":
        if (userType.isCategory) {
          btn1 = (btnEliminar);
          btn2 = (btnVerDetalle);
        } else {
          btn1 = (btnAprobar);
          btn2 = (btnRechazar);
        }
        break;
      case "Finalizado":
      case "Rechazado":
      case "Eliminado":
      case null:
        btn1 = [];
        btn2 = [];
        break;
      default:
        return estadoRebate
    }

    const isFechaNull = fechaInicio === null || fechaVencimiento === null;
    const isRebateFinalizado = ["Finalizado", "Rechazado", "Eliminado", null].includes(estadoRebate);

    const { title, color } = switchCardRebate(estadoRebate); 

    return (
      <div className="rebate-list-card admin-list-card">
        <div className="rebate-list-card__inner">
          <div className="rebate-list-card__head">
            <div className="rebate-list-card__seller">
              <div className="rebate-list-card__seller-name text-truncate" title={descripcionSeller}>
                {descripcionSeller}
              </div>
              <div className="rebate-list-card__seller-meta">
                <span className="rebate-list-card__id-badge" title="Id publicación">
                  {idPublicacion}
                </span>
                <span className={`rebate-list-card__status-pill rebate-status-pill rebate-status-pill--${String(color ?? 'gris')}`}>
                  {title}
                </span>
              </div>
            </div>

            <div className="rebate-list-card__actions" hidden={isRebateFinalizado}>
              <button type="button" className={`btn btn-sm ${btn1.style}`} onClick={btn1.action}>
                {btn1.descripcion}
              </button>
              <button type="button" className={`btn btn-sm ${btn2.style}`} onClick={btn2.action}>
                {btn2.descripcion}
              </button>
            </div>
          </div>

          <div className="rebate-list-card__body">
            <div className="rebate-list-card__product">
              <img
                className="rebate-list-card__img"
                alt={titulo ? `${titulo}` : 'Producto'}
                src={this.resolveImageSrc(imagen)}
              />
              <div className="rebate-list-card__product-main">
                <div className="rebate-list-card__title text-break">{titulo}</div>
                <div className="rebate-list-card__sub">
                  <span className="rebate-list-card__kv">
                    <strong>SKU Seller:</strong>{" "}
                    {this.renderCopyControl(
                      skuSeller,
                      'SKU seller',
                      skuSeller,
                      'rebate-copy-field orden-copy-id',
                      'Clic para copiar SKU seller'
                    )}
                  </span>
                  <span className="rebate-list-card__dot">•</span>
                  <span className="rebate-list-card__kv">
                    <strong>SKU Market:</strong>{" "}
                    {this.renderCopyControl(
                      skuMarket,
                      'SKU market',
                      skuMarket,
                      'rebate-copy-field orden-copy-id',
                      'Clic para copiar SKU market'
                    )}
                  </span>
                </div>
                <div className="rebate-list-card__sub">
                  <span className="rebate-list-card__kv"><strong>Tipo publicación:</strong> {tipoPublicacion?.descripcion ?? ""}</span>
                </div>
              </div>
            </div>

            <div className={`rebate-kpi-card top-color-${color}`}>
              <div className="rebate-kpi-card__top">
                <div className="rebate-kpi-card__discount">
                  {porcentajeTotalDescuento}% OFF
                </div>
                <div className="rebate-kpi-card__date" hidden={isFechaNull}>
                  {fechaInicio?.substr(0, 10)} al {fechaVencimiento?.substr(0, 10)}
                </div>
              </div>

              <div className="rebate-kpi-card__grid">
                <div className="rebate-kpi-card__kpi">
                  <div className="rebate-kpi-card__label">Precio lista</div>
                  <div className="rebate-kpi-card__value">${formatoDecimal(precioLista)}</div>
                </div>

                <div className="rebate-kpi-card__kpi rebate-kpi-card__kpi--highlight">
                  <div className="rebate-kpi-card__label">{isRebateFinalizado ? "Precio rebate" : "Precio final"}</div>
                  <div className="rebate-kpi-card__value">${formatoDecimal(precioFinal)}</div>
                  {!isRebateFinalizado && (
                    <div className="rebate-kpi-card__hint">Precio publicado</div>
                  )}
                </div>

                <div className="rebate-kpi-card__kpi">
                  <div className="rebate-kpi-card__label">A cargo MegaMarket</div>
                  <div className="rebate-kpi-card__value">
                    {porcentajeMegatone}% <span className="rebate-kpi-card__muted">(${formatoDecimal(aCargoMegatone)})</span>
                  </div>
                </div>

                <div className="rebate-kpi-card__kpi">
                  <div className="rebate-kpi-card__label">A cargo seller</div>
                  <div className="rebate-kpi-card__value">
                    {porcentajeSeller}% <span className="rebate-kpi-card__muted">(${formatoDecimal(aCargoSeller)})</span>
                  </div>
                </div>

                <div className="rebate-kpi-card__kpi">
                  <div className="rebate-kpi-card__label">{isRebateFinalizado ? "Unidades vendidas" : "Unidades restantes"}</div>
                  <div className="rebate-kpi-card__value">{isRebateFinalizado ? unidades : unidadesRestantes}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}